import { createEvent } from 'effector';
import { track } from './amplitude';
import { OVERALL_SLIDER_SLIDE_CHANGED } from './events';

/**
 * Engagement-метрики слайдов `OverallSceneOverlay`.
 *
 * Overlay использует two-slot crossfade (НЕ Swiper) — один event на
 * каждую смену активного слайда (`activeIndex`): свайп / тап по
 * pagination-dot на mobile, клик по side-menu / стрелки ←→ на desktop.
 * Эмитится в `driveSideEffects` после фактической смены индекса. На
 * сессию overall обычно 3-10 переключений, не спамит.
 *
 * `slide_key` нормализуется к человекочитаемому id:
 *   - `'welcome'` для welcome-слайда
 *   - URL-id сцены (`'kaaba'` / `'arafat'` / `'mina'` / `'muzdalifah'`)
 *     для scene-слайдов
 *
 * `dwell_on_previous_ms` — сколько ушедший слайд был активным. Для
 * первого переключения это время от mount overlay'а (= как долго
 * пользователь смотрел welcome перед уходом).
 *
 * `triggered_camera_focus: true` означает, что `splatApi` доступен И у
 * слайда найдена `cameraPose` → `transitionToPose` сработал. Камера
 * летит в обоих режимах (mobile и desktop) — поле не зависит от
 * breakpoint'а; `false` только когда api/поза отсутствуют.
 */
export const overallSliderSlideChanged = createEvent<{
  fromKey: string | null;
  toKey: string;
  fromIndex: number;
  toIndex: number;
  dwellOnPreviousMs: number;
  triggeredCameraFocus: boolean;
}>();

export const startOverallTracking = (): void => {
  overallSliderSlideChanged.watch(
    ({ fromKey, toKey, fromIndex, toIndex, dwellOnPreviousMs, triggeredCameraFocus }) => {
      track(OVERALL_SLIDER_SLIDE_CHANGED, {
        from_slide_key: fromKey,
        to_slide_key: toKey,
        from_slide_index: fromIndex,
        to_slide_index: toIndex,
        dwell_on_previous_ms: dwellOnPreviousMs,
        triggered_camera_focus: triggeredCameraFocus,
      });
    },
  );
};
